import * as actionType from "../../../context/actions";
import GetExpenseDataLocal from "./GetExpenseDataInLocal";


const DeleteexpenseDataInLocal = async (state, dispatch, uniqueID) => {

    try {



        // Retrieve existing invoices from localStorage
        let existingData = JSON.parse(localStorage.getItem("LOCAL_EXPENSE")) || [];

        // Find the index of the invoice with the matching invoiceId
        const indexToDelete = existingData.findIndex(expense => expense.uniqueID === uniqueID);

        // Validate if the invoice exists
        if (indexToDelete === -1) {
            return { success: true, message: "Expense deleted successfully!" };
        }

        // Remove the invoice at the found index
        existingData.splice(indexToDelete, 1);

        // Save updated data back to localStorage
        localStorage.setItem("LOCAL_EXPENSE", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Refresh invoice data
        await GetExpenseDataLocal(state, dispatch);

        return { success: true, message: "Expense deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};

export default DeleteexpenseDataInLocal;
